enum ForecastColumnType {
  DATED = "dated",
  NO_CLOSING_DATE = "no_closing_date",
  PAST_CLOSING_DATE = "past_closing_date",
}

export default ForecastColumnType;
